<body class="handling-scan">
  <div class="handling-scan-container">
    <h3 class="page-title">{{ header }}</h3>
    <ion-row>
      <ion-col size="10">
        <app-add-new-scan
          [form]="form"
          [isFormSubmitted]="!!isFormSubmitted()"
          [hasFileUploadButton]="true"
          [triggerAPIOnSubmit]="true"
          [isPTN]="true"
          [fileType]="PARSE_TYPE.TRACKINGNUMBER_ONLY"
          (emitSubmit)="submit($event, false)"
          (emitFileUpload)="submit($event, true)"
        ></app-add-new-scan>
      </ion-col>
      <!-- Icons -->
      @if (dataSource.data.length > 0 && !isFileUpload) {
        <ion-col size="2" class="top-icons ion-no-padding action-btn-column">
          <app-filter-icon
            [isDisabled]="!isFilterEnabled"
            (clearFilterEvent)="clearAllFilters()"
          >
          </app-filter-icon>
        </ion-col>
      }
    </ion-row>

    <!-- Table -->
    @if (dataSource.data.length > 0 && !isFileUpload) {
      <div class="handling-scan-table-container">
        <table
          mat-table
          [dataSource]="dataSource"
          matSort
          class="handling-scan-table"
        >
          <caption>
            OutBound Scan GLE
          </caption>

          <!-- TRACKING_NUMBER -->
          <ng-container matColumnDef="trackingNumber">
            <th mat-header-cell *matHeaderCellDef id="header">
              <app-table-search-component
                [columnName]="COLUMNTEXT.TRACKING_NUMBER"
                [control]="trackingNumberData.formControl"
                [maxLength]="18"
                [textInputWidth]="339"
                [searchIconOffset]="132"
                (emitSearch)="search()"
              ></app-table-search-component>
            </th>

            <td
              mat-cell
              *matCellDef="let inboundScan"
              headers="trackingNumber-headers"
              class="tracking-number-data-column"
            >
              <app-table-tracking-number-cell
                [trackingNumber]="inboundScan.trackingNumber"
              ></app-table-tracking-number-cell>
            </td>
          </ng-container>

          <!-- SORT_DATE -->
          <ng-container matColumnDef="sortDate">
            <th mat-header-cell *matHeaderCellDef id="header">
              <ion-row class="date-column-header th-text">{{
                COLUMNTEXT.SORT_DATE
              }}</ion-row>
              <div
                class="sort-date-picker-container date-picker-container table-sort-date-picker"
              >
                <app-form-date-picker
                  [icon]="SRC.CALENDAR"
                  [placeholder]="CONST.SELECT_DATE"
                  [formControl]="sortDate.formControl"
                  [minDate]="tableMinSortDate"
                  [maxDate]="tableMaxSortDate"
                  [enabledDates]="enabledDates"
                  (valueChange)="search()"
                ></app-form-date-picker>
              </div>
            </th>

            <td
              headers="sortDate-headers"
              class="selectable cursor-pointer sortDate-data-column"
              mat-cell
              *matCellDef="let inboundScan"
            >
              {{ inboundScan.sortDate }}
            </td>
          </ng-container>

          <!-- SORT_CODE -->
          <ng-container matColumnDef="sortCode">
            <th mat-header-cell *matHeaderCellDef id="header">
              <app-table-header-dropdown
                [columnText]="COLUMNTEXT.SORT_CODE"
                [itemId]="sortCode.itemId"
                [searchResults]="sortCodeOption"
                [resetData]="resetSelectDropdowns"
                [showDropdown]="dropdownOpen[0]"
                (dropdownChange)="
                  dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 0)
                "
                (checkboxesUpdated)="
                  onStatusChangeForDropdowns($event, sortCode)
                "
                [popoverStyle]="{ maxWidth: 100, offsetX: -65 }"
              >
              </app-table-header-dropdown>
            </th>

            <td
              headers="sortCode-headers"
              mat-cell
              *matCellDef="let inboundScan"
              class="sortCode-data-column"
            >
              {{ inboundScan.sortCode }}
            </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true"
          ></tr>

          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns; let i = index"
          ></tr>

          <tr class="mat-row" *matNoDataRow>
            <td
              class="mat-cell no-border no-results"
              [attr.colspan]="displayedColumns.length"
            >
              <app-no-results-found></app-no-results-found>
            </td>
          </tr>
        </table>
      </div>
    }

    @if (
      isFileUpload &&
      (commonUtils.fileUploadResponse().accepted > 0 ||
        commonUtils.fileUploadResponse().rejected.length > 0 ||
        commonUtils.fileUploadResponse().itemsNonProcessed.length > 0)
    ) {
      <app-file-upload-results
        [response]="commonUtils.fileUploadResponse()"
      ></app-file-upload-results>
    }
  </div>
</body>
